import React from 'react'
import cn from 'classnames'

import Back from 'app/components/SVGS/Back'

import './styles.scss'
import { ISectionHeaderProps } from './interface'

const SectionHeader: React.FC<ISectionHeaderProps> = ({
  t,
  i18n,
  title,
  selectedOrganizationName,
  backHref,
  backTitle,
  children,
  buttons,
  className = '',
  goBack,
  push,
  location,
}) => {
  const backTitleAlias = backTitle || 'Back'
  return (
    <div className={`section-header ${className}`}>
      <div className="section-header__left">
        {backHref && (
          <div
            className={cn('section-header__control', {
              [`section-header__control__${i18n.language}`]: i18n.language,
            })}
          >
            <div
              className="section-header__icon-btn"
              onClick={() => {
                // in ProTrackActivitiesForm goBack don't work
                if (typeof backHref === 'string') {
                  push({ pathname: backHref, state: location?.state })
                } else {
                  goBack()
                }
              }}
            >
              <Back pathProps={{ fill: '#aab4c0' }} />
              <span className="section-header__back-text">{t(backTitleAlias)}</span>
            </div>
          </div>
        )}
        <div className={`section-header__title ${className}__title`}>
          {title} {selectedOrganizationName ? `- ${selectedOrganizationName}` : null}
        </div>
        <div className={`section-header__title ${className}__title`}>{buttons}</div>
      </div>
      <div className="section-header__right">{children}</div>
    </div>
  )
}

export default SectionHeader
